export default __webpack_public_path__ + "static/media/not-attempted.0b70c255.svg";